import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild, NgZone } from '@angular/core';
import { MessageService, SelectItem, MenuItem } from 'primeng/api';
import { Store, select } from '@ngrx/store';
import * as fromStore from '../../store';
import { Observable, of, Subject, Subscription, combineLatest } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';

import { ActivatedRoute } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { DeviceGroupParam } from '../../models/group';
import { updateInfoType, PackageList, addDeviceByCard, errMsgForExceedLimit, urlPath, geteventEmitterType,
  planChargeInfo, ReLoadDashboardSec } from '../../shareModel';
import * as share from '../../shareModel';
import * as fromMyfeatures from '../../my-features/';
import { UpdateInfoModel } from '../../my-features/updateInfo/update-info.model';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { isODM } from '../../../environments/environment';
import { Confirm_button } from '../../../environments/environment';
import {AddUpdateDeviceParams, ConnectWifiParams, MiniCardParams, WifiCardInfo, EmbCardParams,
   MiniCardWithoutPackParams} from '../../models/devices';
import { DevicesService } from '../../services/devices.service';
import { DialogComponent } from '../../../app/dialog/dialog.component';
import { BtyReplacementParams } from '../../my-features/battery-replacement/battery-replacement.model';
import { TranslateService } from '@ngx-translate/core';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import * as fromFeature from '../../my-features';
import {CryptoService} from '../../services/crypto.service';
import {PreferenceService} from '../../services/preference.service';
import { Router } from '@angular/router';
import { LanguageService } from '../../services/language.service';
import { RegionService } from 'src/app/services/region.service';
import { User } from '../../models/user';
import { Group } from '../../models/group';
// import * as moment from 'moment';
@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit, OnDestroy {
  @ViewChild('LEDcolor', { static: false }) RCCDialogLEDcolor;
  @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;
  defaultHomePage = 0;
  powerMaster = isODM;
  Confirm_button = Confirm_button;
  selectedStatus = -1;
  selectedStatusRwd = -1;
  view: SelectItem[] = [
    { title: TRANSLATE('Grid View'), value: 'grid', icon: 'fa fa-th-large' },
    { title: TRANSLATE('Small Grid View'), value: 'small-grid', icon: 'fa fa-th' },
    { title: TRANSLATE('List View'), value: 'list', icon: 'fa fa-list' },
  ];
  selectedView = 'grid';
  selectedSort: boolean = true;
  selectedTabIndex = "0";
  statusOptions: any;
  refreshTime: Date = new Date();
  display = false;
  displayAddDeviceDialog = false;
  addDeviceList = [];
  DeviceOptionList = [];
  mspCompanyOptions = [];
  new_mspCompany_Options_For_Device = [];
  new_mspCompany_Options_For_Group = [];
  deviceSelectItem: any[] = [];
  private componentDestroyed = new Subject();
  groupIsErrorFlag = {
    gName: false,
    timeZone: false,
    devices: false,
    company: false
  };
  deviceGroupParam = {} as DeviceGroupParam;
  UpdateInfoParam = {} as UpdateInfoModel;
  timezoneOptions: SelectItem[] = share.timeZoneOption;
  groupFeature: Boolean;
  account: string;
  dashBoardPage: Boolean;
  miniCardParams: MiniCardParams = {
    otp: '',
    mac: '',
    key: '',
  };
  embCardParams: EmbCardParams = {
    otp: '',
    mac: '',
    key: '',
  };
  dialogMiniCardSaveDirty = false;
  isCompleted = false;
  addUpsParams: AddUpdateDeviceParams = {
    LoginType: 10,
    OtpKey: '',
    DeviceType: 0,
    DeviceName: '',
    Model: '',
    DeviceSn: '',
    FirmwareVersion: '',
    rSN: '',
    rType: 1,
  };
  readObjectSharingParam = {owner_acode: 0, shared_acode: 0, RegionIds: null};

  groupCnt: number;
  groupLimit: number;
  dialogGroupSaveDirty = false;
  items: MenuItem[];
  RCCdisplay = false;
  RWCCdisplay = false;
  WiFiNetworkList: any;
  selectedWiFiNetwork: any;
  RCCTabIndex = 0;
  MACNumber = '';
  KeyNumber = '';
  dialogMACNumberSaveDirty = false;
  dialogKeyNumberSaveDirty = false;
  RWCCTabIndex = 0;
  WiFipassword = '';
  RWCCDeviceName = '';
  companySelectItem: string;
  RCCDeviceName = '';
  RCCCompanySelectItem: string;
  blockedPanel = false;
  RWCCdialogHeader: string;
  RCCdialogHeader: string;
  AddDeviceType = false;
  miniCardInfor: any;
  saveRCCDeviceNameType: number;
  wifiCardParams: AddUpdateDeviceParams = {};
  step2StayingTimer: any;
  otp: string;
  acode: number;
  hashOtp: string;
  now = new Date();
  selectorOpen = false;
  pageloading = true;
  regionDic: any = [];
  UserParam = {} as User;
  GroupParam = {} as Group;
  count = 0;
  isMsp = false;
  mspRegionFilter: any;
  mspMemberAuthorityDic = {};
  usingPlanName: string;
  NotMspDeviceInfoIsRead = false;
  searchKeyWord: string = '';
  sortType: boolean = true;
  intervalId: any = null;
  lastActionTime = Date.now();
  CHECK_INTERVAL = 1000; // 每秒檢查一次
  constructor(
    private translateService: TranslateService,
    private store: Store<fromStore.State>,
    private loadingBar: LoadingBarService,
    private ngxService: NgxUiLoaderService,
    private messageService: MessageService,
    private preferenceService: PreferenceService,
    private deviceService: DevicesService,
    private cryptoService: CryptoService,
    private router: Router,
    private languageService: LanguageService,
    private regionService: RegionService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
  ) {
    if (this.powerMaster) {
      this.CheckCustmizeDomain();
    }

    // Initial selection
    this.store.dispatch(new fromStore.SelectedSatus(Number(-1)));
    // Deprecated
    this.store
      .select(fromStore.getCurrentUser)
      .pipe(first())
      .subscribe((res) => {
        this.otp = res.otp;
        const hashTime = new Date(
          this.now.getFullYear(),
          this.now.getMonth(),
          this.now.getDate()
        ).getTime();
        this.hashOtp = this.cryptoService.hashHmacSha1(this.otp + hashTime);
        this.acode = res.acode;
        this.account = res.currentUser;
        // this.miniCardParams.otp = res.otp;
        // this.addUpsParams.Account = res.currentUser;
        // this.addUpsParams.OtpKey = res.otp;
        // this.addUpsParams.CreateUser = res.currentUser;
        this.readObjectSharingParam = {
          ...this.readObjectSharingParam,
          shared_acode: this.acode,
        };
      });

    // Get group limit
    this.store
      .select(fromStore.getGroupCount)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        this.groupCnt = res;
      });

    // Get update or check information
    this.store
      .select(fromStore.getUpdateInfoState)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res.isLoaded && !res.isLoading) {
          // Add Group
          if (res.type === updateInfoType.DeviceGroup) {
            if (res.isSaved) {
              this.messageService.add({
                severity: 'success',
                summary: this.translateService.instant(
                  TRANSLATE('Update Success')
                ),
              });
              this.resetGroupField();
              this.refresh();
            } else {
              let errSummary: string = TRANSLATE('Update Fail');
              if (res.msg === '0') {
                errSummary = errMsgForExceedLimit.GroupLimit['0'];
              }
              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant(errSummary),
              });
            }
            this.ReLoadUpdateState();
          }

          // Bind mini card
          if (res.type === updateInfoType.BindMiniCard) {
            if (res.isSaved) {
              const miniCardInfo = res.msg;
              switch (miniCardInfo.result_code) {
                case 0:
                case 6: // Successful, it need to input the device name on the next step.(Without package)
                  this.saveRCCDeviceNameType = 1;
                  this.RCCTabIndex = 2;
                  break;
                case 7: // Successful, only need to connect the device with card.
                  this.RCCdisplay = false;
                  this.childDialog.dialogType.RCC_ResultDoubleCheck = true;
                  this.store.dispatch(new fromMyfeatures.ClearBindMiniCards());
                  break;
                case 1: // Successful, it need to input the device name on the next step.
                  this.saveRCCDeviceNameType = 0;
                  this.RCCTabIndex = 2;
                  break;
                case 3: // MAC Not Exist
                  this.RCCdisplay = false;
                  this.childDialog.dialogType.RCC_ResultNotExist = true;
                  this.store.dispatch(new fromMyfeatures.ClearBindMiniCards());
                  break;
                case 4:
                case 5:
                case 8: // duplicated
                  this.RCCdisplay = false;
                  this.childDialog.dialogType.RCC_ResultExist = true;
                  this.store.dispatch(new fromMyfeatures.ClearBindMiniCards());
                  break;
                case 2:
                  if (!miniCardInfo.haveUPS) {
                    this.saveRCCDeviceNameType = 1;
                    this.RCCTabIndex = 2;
                  }
                  break;
                default:
                  this.childDialog.dialogType.RCC_ResultExist = true;
                  this.RCCdisplay = false;
                  this.store.dispatch(new fromMyfeatures.ClearBindMiniCards());
              }
            } else {
              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant('Update Fail'),
              });
            }
            this.ReLoadUpdateState();
          }

          // Bind Emb card
          if (res.type === updateInfoType.BindEmbCard) {
            if (res.isSaved) {
              const embCardInfo = res.msg;
              switch (embCardInfo.result_code) {
                case 0:
                case 6: // Successful, it need to input the device name on the next step.(Without package)
                  this.saveRCCDeviceNameType = 1;
                  this.RCCTabIndex = 2;
                  break;
                case 7: // Successful, only need to connect the device with card.
                  this.RCCdisplay = false;
                  this.childDialog.dialogType.RCC_ResultDoubleCheck = true;
                  this.childDialog.dialogType.RCC_AddDeviceType = this.AddDeviceType;
                  this.store.dispatch(new fromMyfeatures.ClearEmbCards());
                  break;
                case 1: // Successful, it need to input the device name on the next step.
                  this.saveRCCDeviceNameType = 0;
                  this.RCCTabIndex = 2;
                  break;
                case 3: // MAC Not Exist
                  this.RCCdisplay = false;
                  this.childDialog.dialogType.RCC_ResultNotExist = true;
                  this.store.dispatch(new fromMyfeatures.ClearEmbCards());
                  break;
                case 4:
                case 5:
                case 8: // duplicated
                  this.RCCdisplay = false;
                  this.childDialog.dialogType.RCC_ResultExist = true;
                  this.store.dispatch(new fromMyfeatures.ClearEmbCards());
                  break;
                case 2:
                  if (!embCardInfo.haveUPS) {
                    this.saveRCCDeviceNameType = 1;
                    this.RCCTabIndex = 2;
                  }
                  break;
                default:
                  this.childDialog.dialogType.RCC_ResultExist = true;
                  this.RCCdisplay = false;
                  this.store.dispatch(new fromMyfeatures.ClearEmbCards());
              }
            } else {
              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant('Update Fail'),
              });
            }
            this.ReLoadUpdateState();
          }

          // Bind Device
          if (res.type === updateInfoType.BindDevice) {
            const result = res.msg; // 1: Wifi card, 2: Mini card, 3:Emb card.
            this.ngxService.stop();
            if (res.isSaved) {
              switch (result) {
                case 1:
                  this.RWCCdisplay = false;
                  this.childDialog.dialogType.RWCC_ResultSuccess = true;
                  break;
                case 2:
                case 3:
                  this.RCCdisplay = false;
                  this.childDialog.dialogType.RCC_ResultSuccess = true;
                  break;
                default:
                  this.RCCdisplay = false;
                  this.RWCCdisplay = false;
              }
            } else {
              switch (result) {
                case 1:
                  this.childDialog.dialogType.RWCC_ConnectedNoInternet = true;
                  break;
                case 2:
                case 3:
                  this.childDialog.dialogType.RWCC_ConnectedFailed = true;
                  this.RCCdisplay = false;
                  break;
                default:
                  this.RWCCdisplay = false;
                  this.RCCdisplay = false;
                  this.messageService.add({
                    severity: 'error',
                    summary: this.translateService.instant('Update Fail'),
                  });
              }
            }
            this.ReLoadUpdateState();
          }

          // Bind Device
          if (res.type === updateInfoType.BindDeviceWithoutPack) {
            const result = res.msg; // 1: Wifi card, 2: Mini card, 3:Emb card.
            this.ngxService.stop();
            if (res.isSaved) {
              switch (result) {
                case 2:
                case 3:
                  this.RCCdisplay = false;
                  this.childDialog.dialogType.RCC_ResultDoubleCheck = true;
                  this.store.dispatch(new fromMyfeatures.ClearBindMiniCards());
                  break;
                default:
                  this.RCCdisplay = false;
                  this.RWCCdisplay = false;
              }
            } else {
              switch (result) {
                case 2:
                case 3:
                  this.childDialog.dialogType.RWCC_ConnectedFailed = true;
                  this.RCCdisplay = false;
                  break;
                default:
                  this.RWCCdisplay = false;
                  this.RCCdisplay = false;
                  this.messageService.add({
                    severity: 'error',
                    summary: this.translateService.instant('Update Fail'),
                  });
              }
            }
            this.ReLoadUpdateState();
          }

          // Get wifi card response.
          if (res.type === updateInfoType.GetWifiCard) {
            if (res.isSaved) {
              this.childDialog.dialogType.RWCC_Connected = true;
            } else {
              // 待處理 time out
              this.childDialog.dialogType.RWCC_NoWifi = true;
            }
            this.ReLoadUpdateState();
          }

          // Get wifi list.
          if (res.type === updateInfoType.GetWifiList) {
            if (res.isSaved) {
              this.store.dispatch(new fromMyfeatures.ChangStepWifiCards(3));
            } else {
              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant('Update Fail'),
              });
            }
            this.ReLoadUpdateState();
          }

          // Get wifi connection result.
          if (res.type === updateInfoType.GetConnectWifi) {
            if (res.isSaved) {
              // Cancel revise the device name on add device process.
              // this.store.dispatch(new fromMyfeatures.ChangStepWifiCards(6));
              // this.RWCCDeviceName = '';
              // When the device connected, dispatch BindDevice with success.
              // const updateRes: UpdateInfoModel = {
              //   result: true,
              //   msg: 1, // Wifi card
              //   type: updateInfoType.BindDevice
              // };
              // return this.store.dispatch(new fromMyfeatures.UpdateInfoSuccessAction(updateRes));
              console.log('Wait for connect to internet');
              setTimeout(() => {
                console.log('Add device.');
                this.saveRWCCDevice();
              }, 12000);
            } else {
              if (this.RWCCTabIndex === 5) {
                this.childDialog.dialogType.RWCC_WifiPwdError = true;
                this.store.dispatch(new fromMyfeatures.ChangStepWifiCards(4)); // Connection failed, back to input the wifi password.
              }
            }
            this.ReLoadUpdateState();
          }
        }
      });

    // Get RCC Information
    this.store
      .select(fromStore.getBindMiniCardState)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        this.miniCardInfor = res.entity;
      });

    // Get RWC Information
    this.store
      .select(fromStore.getWifiCardState)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res) {
          // Step procedures.
          if (this.RWCCTabIndex !== Number(res.wifiCardStep)) {
            this.RWCCTabIndex = Number(res.wifiCardStep);
            switch (Number(res.wifiCardStep)) {
              case 2:
                this.store.dispatch(new fromMyfeatures.GetBindWifiCards()); // connectRWCCWiFi
                break;
              case 3:
                this.store.dispatch(new fromMyfeatures.GetWifiList());
                break;
              case 5:
                const wifiParams: ConnectWifiParams = {
                  ssid: this.selectedWiFiNetwork.value,
                };
                if (this.selectedWiFiNetwork.password === 1) {
                  wifiParams.password = this.WiFipassword;
                }
                this.store.dispatch(
                  new fromMyfeatures.GetConnectWifi(wifiParams)
                );
                break;
              default:
            }

            if (this.step2StayingTimer) {
              clearTimeout(this.step2StayingTimer);
            }
            // if stay to long:
            if (
              this.RWCCTabIndex === 2 &&
              !this.childDialog.dialogType.RWCC_Connected
            ) {
              this.step2StayingTimer = setTimeout(() => {
                if (
                  this.RWCCTabIndex === 2 &&
                  !this.childDialog.dialogType.RWCC_Connected &&
                  !this.childDialog.dialogType.RWCC_NoWifi
                ) {
                  this.ChangStepWifiCards(1);
                  this.childDialog.dialogType.RWCC_NoWifi = true;
                }
              }, 1000 * 120); // wait for 2 min.
            }
          }

          // Get wifi list.
          this.WiFiNetworkList = res.wifiList.map((item) => {
            return {
              label: item.ssid,
              value: item.ssid,
              password: item.password,
            };
          });

          // Wifi list loading state.
          if (!res.wifiListState.Loaded && res.wifiListState.Loading) {
            this.blockedPanel = true;
          } else {
            this.blockedPanel = false;
          }

          // Wifi card information.
          if (
            res.wifiCardState.Loaded &&
            !res.wifiCardState.Loading &&
            res.wifiCardInfo
          ) {
            const newMac = res.wifiCardInfo.mac.replace(/:/g, '').substr(-6); // Get last 6 numbers
            this.wifiCardParams = {
              ...this.wifiCardParams,
              rType: 1, // 1: Wifi Card, 2: Mini Card
              LoginType: 10, // Web Login
              DeviceType: 0, // UPS
              Model: res.wifiCardInfo.model || '',
              DeviceSn: res.wifiCardInfo.sn || '', // Wifi card
              FirmwareVersion: res.wifiCardInfo.firmware_version || '',
              rSN: newMac,
            };
          }
        }
      });

    // Chang Menu Language after selection was changed.
    this.translateService.onLangChange
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        this.view[0].title = this.translateService.instant('Grid View');
        this.view[1].title = this.translateService.instant('Small Grid View');
        this.view[2].title = this.translateService.instant('List View');
        this.packageSetting();
      });

    // Get Update Info
    this.store
      .select(fromStore.getUpdateInfoState)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        // Activate Trial License
        if (res.type === updateInfoType.ActivateTrialLicense) {
          if (!res.isLoading && res.isLoaded && res.isSaved) {
            if (this.isMsp) {
              const userParam = { ...this.UserParam, regionIds: this.mspRegionFilter.regionIds } as User;
              this.store.dispatch(new fromStore.GetDevicesStatusAction(userParam));
            } else {
              this.store.dispatch(new fromStore.GetDevicesStatusAction());
            }
            this.messageService.add({
              severity: 'success',
              summary: TRANSLATE('Your free trial is activated'),
            });
          } else if (!res.isLoading && res.isLoaded && !res.isSaved) {
            this.messageService.add({
              severity: 'error',
              summary: TRANSLATE('Failure: please try again later'),
            });
          }
          this.ReLoadUpdateState();
        }

        // Share Device
        if (res.type === updateInfoType.AddDeviceSharingInfo ||
          res.type === updateInfoType.UpdateDeviceSharingInfo || res.type === updateInfoType.DeleteDeviceSharingInfo) {
          if (!res.isLoading && res.isLoaded) {
            if (res.isSaved) {
              this.messageService.add({ severity: 'success', summary: 'Update Success', });
              this.refresh();
            } else if (!res.isSaved) {
              this.messageService.add({ severity: 'error', summary: 'Update Fail', });
            }
            this.ngxService.stop();
          }
          this.resetUpdateInfoState();
        }
        // Share Group
        if (res.type === updateInfoType.AddGroupSharingInfo ||
          res.type === updateInfoType.UpdateGroupSharingInfo || res.type === updateInfoType.DeleteGroupSharingInfo) {
          if (!res.isLoading && res.isLoaded) {
            if (res.isSaved) {
              this.messageService.add({ severity: 'success', summary: 'Update Success' });
              // 與手動整理同一條路徑，避免只重撈部分 API / 錯誤 RegionIds 導致 Device 清單被清空
              this.refresh();
            } else if (!res.isSaved) {
              this.messageService.add({ severity: 'error', summary: 'Update Fail' });
            }
            this.ngxService.stop();
          }
          this.resetUpdateInfoState();
        }
      });

    // this.regionService.geteventEmitter.pipe(takeUntil(this.componentDestroyed)).subscribe((eventData) => {
    //   if (eventData === geteventEmitterType.SelectByRegion) {
    //     this.refresh();
    //   }
    // });

    this.store.select(fromStore.getMspRegionFilter).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      this.mspRegionFilter = null;
      // if (res !== null && res.filterLoaded) {
      //   this.isMsp = res.isMsp;
      //   if (res.isMsp) {
      //     this.mspRegionFilter = res.selectedId;
      //     this.readObjectSharingParam.RegionIds = res.selectedId;
      //   }
      //   this.store.dispatch(new fromFeature.GetDeviceSharingList(this.readObjectSharingParam));
      //   this.store.dispatch(new fromFeature.GetGroupSharingList(this.readObjectSharingParam));
      // }
      if (res !== null) {
        this.mspRegionFilter = res.selectedId;
        this.isMsp = res.isMsp;
        if (res.isMsp && res.filterLoaded) {
          this.mspRegionFilter = res.selectedId;
          this.readObjectSharingParam = { ...this.readObjectSharingParam, RegionIds: res.selectedId };
          this.store.dispatch(new fromFeature.GetDeviceSharingList({ ...this.readObjectSharingParam }));
          this.store.dispatch(new fromFeature.GetGroupSharingList({ ...this.readObjectSharingParam }));
        } else if (!res.isMsp && !this.NotMspDeviceInfoIsRead) {
          this.store.dispatch(new fromFeature.GetDeviceSharingList({ ...this.readObjectSharingParam }));
          this.store.dispatch(new fromFeature.GetGroupSharingList({ ...this.readObjectSharingParam }));
          this.NotMspDeviceInfoIsRead = true;
        }
      }
    });

    combineLatest(this.store.select(fromStore.getMspRegionOptions), this.store.select(fromStore.getMspMemberAuthority))
    .pipe(takeUntil(this.componentDestroyed)).subscribe(([option, auth, ]) => {
      this.mspMemberAuthorityDic = {};
      this.new_mspCompany_Options_For_Device = this.new_mspCompany_Options_For_Group = option ? option.filter(opt => {
        const region_auth = auth ? auth.find(i => i.RegionId === opt.value) : null;
        return (region_auth && region_auth.EditDevice === 1);
      }) : null;

      if (this.isMsp && auth !== undefined) {
        auth.map((m) => {
          this.mspMemberAuthorityDic[m.RegionId] = m;
        });
      }
    });

    this.store.select(fromStore.getAddDevicesListToGroup).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      this.DeviceOptionList = res;
      if (!this.isMsp) {
        this.addDeviceList = res;
      }
    });

    // v1.8.5.2 調整邏輯: SL => 沒有Group功能
    combineLatest(this.store.select(fromStore.getPlanSetting), this.store.select(fromStore.getIsActiveUserModule, PackageList.Group))
    .pipe(takeUntil(this.componentDestroyed)).subscribe(([plan, res, ]) => {
      if (plan.Loaded && !plan.Loading) {
        const usingPlan = Object.values(plan.entities).find((i) => i.Status === 1);  // filter out using one.
        if (usingPlan) {
          this.usingPlanName = usingPlan.PlanName;
        }
      }
      this.groupFeature = Boolean(res);
        if (this.powerMaster) {
          this.RCCdialogHeader = this.translateService.instant(
            TRANSLATE('Add Device by CMCARD-E')
          );
          this.RWCCdialogHeader = this.translateService.instant(
            TRANSLATE('Add Device by CMCARD-W')
          );
          this.items = [
            {
              label: this.translateService.instant(TRANSLATE('Add Group')),
              command: () => {
                this.addGroup();
              },
            },
            {
              label: this.translateService.instant(
                TRANSLATE('Add Device by CMCARD-W')
              ),
              command: () => {
                // this.addRWCC();
                this.router.navigate([
                  `/add-device/${
                    this.languageService.getLanguage
                  }/${this.hashOtp.toLowerCase()}${this.otp}`,
                ]);
              },
            },
            {
              label: this.translateService.instant(
                TRANSLATE('Add Device by CMCARD-E')
              ),
              command: () => {
                this.addRCC(false);
              },
            },
          ];
        } else {
          this.RCCdialogHeader = this.translateService.instant(
            TRANSLATE('Add Device by Remote Cloud Card')
          );
          this.RWCCdialogHeader = this.translateService.instant(
            TRANSLATE('Add Device by Remote Wireless Cloud Card')
          );
          this.items = [];
          if (this.usingPlanName !==  planChargeInfo[`level_1N`].name) {
            this.items.push({
              label: this.translateService.instant(TRANSLATE('Add Group')),
              command: () => {
                this.addGroup();
              },
            });
          }
          this.items.push({
            label: this.translateService.instant(
              TRANSLATE('Add Device by Remote Wireless Cloud Card')
            ),
            command: () => {
              // this.addRWCC();
              this.router.navigate([
                `/add-device/${
                  this.languageService.getLanguage
                }/${this.hashOtp.toLowerCase()}${this.otp}`,
              ]);
            },
          },
          {
            label: this.translateService.instant(
              TRANSLATE('Add Device by Remote Cloud Card')
            ),
            command: () => {
              this.RCCdialogHeader = this.translateService.instant(
                TRANSLATE('Add Device by Remote Cloud Card')
              );
              this.addRCC(false);
            },
          },
          {
            label: this.translateService.instant(
              TRANSLATE('Add Device By Cloud UPS')
            ),
            command: () => {
              this.RCCdialogHeader = this.translateService.instant(
                TRANSLATE('Add Device By Cloud UPS')
              );
              this.addRCC(true);
            },
          });
        }
        if (!this.groupFeature) {
          this.items.unshift();
        }
    });
  }

  ReLoadUpdateState() {
    this.resetUpdateInfoState();
    this.ngxService.stop();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(
      new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam })
    );
  }

  private dispatchUpdateInfoAction(type: string): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(
      new fromMyfeatures.UpdateInfoAction({ ...this.UpdateInfoParam })
    );
  }

  ngOnInit() {
    this.defaultHomePage = this.preferenceService.GetDefaultHomePage;
    this.pageloading = true;
    this.packageSetting();
    this.UI();
    this.Init();
    if (this.powerMaster) {
      this.selectedView = 'list';
    } else {
      if (this.defaultHomePage === 2) {
        this.regionService.triggerEvent(geteventEmitterType.SelectTab);
        this.selectedView = 'list';
      } else if (this.defaultHomePage === 3) {
        this.regionService.triggerEvent(geteventEmitterType.SelectTab);
        this.selectedView = 'small-grid';
      } else {
        this.selectedView = 'grid';
      }
    }
    // this.refresh();
    // this.store.dispatch(new fromFeature.GetMspMemberRegions());
    this.initListener();
    this.initInterval();
  }

  Init() {
    this.ngxService.start();
    this.pageloading = true;
    this.store
      .select(fromStore.getDevicesTypeCount)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        this.statusOptions = res;
        if (!res.isLoading && res.isLoaded && res.data) {
          this.ngxService.stop();
          setTimeout(() => {
            this.pageloading = false;
            this.cdr.detectChanges();
          }, 0);
        }
      });
    this.store
      .select(fromStore.getSelectedDashboardStatusState)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        this.selectedStatus = res;
        this.selectedStatusRwd = res;
      });

    // this.store.dispatch(new fromFeature.GetDeviceSharingList({ shared_acode: this.acode }));
    // this.store.dispatch(new fromFeature.GetGroupSharingList(this.readObjectSharingParam));
  }

  closeRCCDialog(event) {
    this.RCCDialogLEDcolor.hide();
    if (this.selectorOpen) {
        this.selectorOpen = false;
    }
    this.RCCdisplay = false;
  }

  refresh() {
    this.ngxService.start();
    this.pageloading = true;
    if (this.isMsp) {
      const param = {
        regionIds : this.mspRegionFilter
      };
      const userParam = { ...this.UserParam, regionIds: param.regionIds } as User;
      this.store.dispatch(new fromStore.GetDevicesStatusAction(userParam));
      this.store.dispatch(new fromStore.GetGroups(param));
      this.store.dispatch(new fromStore.GetDeviceInfoAction(param));
      const btyRepParam = { RegionIds: this.mspRegionFilter } as BtyReplacementParams;
      this.store.dispatch(
        new fromMyfeatures.GetBatteryReplacements(btyRepParam)
      );
      const sharingParam = { ...this.readObjectSharingParam, RegionIds: param.regionIds };
      this.store.dispatch(new fromFeature.GetDeviceSharingList(sharingParam));
      this.store.dispatch(new fromFeature.GetGroupSharingList(sharingParam));
    } else {
      this.store.dispatch(new fromStore.GetDevicesStatusAction());
      this.store.dispatch(new fromStore.GetGroups());
      this.store.dispatch(new fromStore.GetDeviceInfoAction());
      this.store.dispatch(
        new fromMyfeatures.GetBatteryReplacements({} as BtyReplacementParams)
      );
      this.store.dispatch(new fromFeature.GetDeviceSharingList({ ...this.readObjectSharingParam }));
      this.store.dispatch(new fromFeature.GetGroupSharingList({ ...this.readObjectSharingParam }));
    }
    // this.basedOnModeofTrack();
    this.refreshTime = new Date();
    this.display = false;
    this.onKeywordChange();
    this.onSortChange();
  }

  addGroup() {
    this.resetGroupField();
    this.filterDevice();
    // 若Group數量達到數量limit
    if (this.groupLimit <= this.groupCnt) {
      this.childDialog.dialogType.groupLimit = true;
      return;
    }
    this.dialogGroupSaveDirty = false;
    this.display = true;
  }

  addGroupSave() {
    this.dialogGroupSaveDirty = true;
    let valid = true;
    if (
      typeof this.deviceGroupParam.gName !== 'undefined' &&
      this.deviceGroupParam.gName !== ''
    ) {
      this.groupIsErrorFlag.gName = false;
    } else {
      this.groupIsErrorFlag.gName = true;
      valid = false;
    }
    if (this.deviceGroupParam.timeZone !== null) {
      this.groupIsErrorFlag.timeZone = false;
    } else {
      this.groupIsErrorFlag.timeZone = true;
      valid = false;
    }
    if (this.isMsp && this.deviceGroupParam.companySelectItem === undefined) {
      this.groupIsErrorFlag.company = true;
      valid = false;
    } else {
      this.groupIsErrorFlag.company = false;
    }
    this.groupIsErrorFlag.devices = true;
    if (!valid) {
      return;
    }
    // 組device, sharedevice參數
    // this.deviceGroupParam.devices = this.deviceSelectItem
    //   .filter(
    //     (item) =>
    //       this.deviceGroupParam.deviceSelectItem.includes(item.value) &&
    //       !item.is_shared
    //   ).map((item) => item.value);
    this.deviceGroupParam = {
      ...this.deviceGroupParam,
      devices: this.deviceGroupParam.deviceSelectItem,
    };

    this.dispatchUpdateInfoAction(updateInfoType.DeviceGroup);
    this.store.dispatch(new fromStore.AddDeviceGroup({ ...this.deviceGroupParam }));
    this.ngxService.start();
  }

  resetGroupField() {
    this.deviceGroupParam = {
      devices: [],
      devices_selected: [],
      // shared_devices: [],
      timeZone: null,
    } as DeviceGroupParam;
    this.groupIsErrorFlag.gName = false;
    this.groupIsErrorFlag.timeZone = false;
    this.groupIsErrorFlag.devices = false;
    this.groupIsErrorFlag.company = false;
  }

  ChangStepWifiCards(step) {
    this.store.dispatch(new fromMyfeatures.ChangStepWifiCards(step));
  }

  // Depricated
  // resetDeviceField() {
  //   this.miniCardParams.key = '';
  //   this.miniCardParams.mac = '';
  // }
  //
  // addDeviceSave() {
  //   this.dialogMiniCardSaveDirty = true;
  //   this.miniCardParams.key = this.miniCardParams.key.toUpperCase();
  //   if (this.miniCardParams.key === '' || this.miniCardParams.mac === '') {
  //     return;
  //   }
  //   this.deviceService.addMiniCard(this.miniCardParams).subscribe(res => {
  //     if (res.result) {
  //        this.resetDeviceField();
  //       const code = res['msg']['result_code'];
  //       // result_code: int
  //       // 0:add success but no ups
  //       // 1:add rmc success but need to add ups
  //       // 2, rmc already in your account
  //       // 3: mac and key is not match
  //       // Latest log: string; latest ups log(json), use to get ups basic info
  //       if (code === 1) {
  //         const jsonParseStr = JSON.parse(res['msg']['lastest_log']);
  //         this.addUps(jsonParseStr);
  //       } else {
  //         if (addDeviceByCard.hasOwnProperty(code)) {
  //           this.messageService.add({ severity: addDeviceByCard[code].severity, summary: addDeviceByCard[code].summary });
  //         } else {
  //           this.messageService.add({ severity: 'error', summary: 'Error' });
  //         }
  //         this.refresh();
  //       }
  //     }
  //     this.displayAddDeviceDialog = false;
  //   });
  // }

  addUps(obj) {
    // this.addUpsParams.Model = obj['Model'];
    // this.addUpsParams.DeviceName = obj['Model'];
    // this.addUpsParams.FirmwareVersion = obj['FV'];
    // this.addUpsParams.DeviceSn = obj['SN'];
    // this.deviceService.addUpdateDevice(this.addUpsParams).subscribe(res => {
    //   // console.log(res);
    //   if (res.Flag) {
    //     this.messageService.add({ severity: 'success', summary: 'Add device successfully.' });
    //   } else {
    //     this.messageService.add({ severity: 'error', summary: 'Error.' });
    //   }
    //   this.refresh();
    // });
  }

  filterDevice() {
    if (this.isMsp) {
      this.addDeviceList = [];
    }
    this.deviceSelectItem = [];
    this.store
      .select(fromStore.getEditDevicesListToGroup, {
        gId: this.deviceGroupParam.gId,
      })
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        res.map((item) => {
          this.deviceSelectItem.push(item);
        });
      });
  }

  packageSetting() {

    // Dashboard Page
    this.store
      .select(fromStore.getIsActiveUserModule, PackageList.Dashboard)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        this.dashBoardPage = Boolean(res);
      });

    // Group Limit
    this.store
      .select(fromStore.getIsActiveUserModule, PackageList.GroupLimit)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        this.groupLimit = Number(res);
      });
  }

  statusChanged() {
    this.store.dispatch(new fromStore.SelectedSatus(this.selectedStatus));
    this.selectedStatusRwd = this.selectedStatus;
    this.onKeywordChange();
    this.onSortChange();
  }

  rwdStatusChanged() {
    this.store.dispatch(new fromStore.SelectedSatus(this.selectedStatusRwd));
    this.selectedStatus = this.selectedStatusRwd;
    this.onKeywordChange();
    this.onSortChange();
  }

  MspCompanyChanged() {
    if (this.isMsp) {
      this.addDeviceList = [...this.DeviceOptionList.filter(item => item.regionId === this.deviceGroupParam.companySelectItem)];
    }
  }

  addRCC(type) {
    // Initial the form
    this.AddDeviceType = type;
    this.RCCdisplay = true;
    this.MACNumber = '';
    this.KeyNumber = '';
    this.RCCTabIndex = 0;
    this.RCCCompanySelectItem = '';
  }

  checkRCCMacName() {
    this.ngxService.start();
    const params: MiniCardParams = {
      mac: this.MACNumber,
      key: this.KeyNumber,
      RegionId: this.RCCCompanySelectItem !== '' ? Number(this.RCCCompanySelectItem) : 0
    };
    this.RCCDeviceName = '';
    this.store.dispatch(new fromMyfeatures.GetBindMiniCards(params));
  }

  checkRCCEMBMacName() {
    this.ngxService.start();
    const params: EmbCardParams = {
      mac: this.MACNumber,
      key: this.KeyNumber,
      RegionId: this.RCCCompanySelectItem !== '' ? Number(this.RCCCompanySelectItem) : 0
    };
    this.RCCDeviceName = '';
    this.store.dispatch(new fromMyfeatures.GetBindEmbCards(params));
  }

  saveRCCDeviceName() {
    this.ngxService.start();
    if (this.saveRCCDeviceNameType === 0) {
      this.miniCardInfor = {
        ...this.miniCardInfor,
        DeviceName: this.RCCDeviceName,
        RegionId: this.RCCCompanySelectItem !== '' ? Number(this.RCCCompanySelectItem) : 0,
      };
      this.store.dispatch(new fromMyfeatures.GetBindDevices({ ...this.miniCardInfor }));
    }
    if (this.saveRCCDeviceNameType === 1) {
      const param: MiniCardWithoutPackParams = {
        otp: this.otp,
        rSN: this.MACNumber.replace(/:/g, '').substr(-6), // Get last 6 numbers
        name: this.RCCDeviceName,
        rType: 2 // 1: Wifi Card, 2: Mini Card
      };
      this.store.dispatch(new fromMyfeatures.GetBindDevicesWithoutPack(param));
    }
  }

  saveRCCEMBDeviceName() {
    this.ngxService.start();
    // this.miniCardInfor.DeviceName = this.RCCDeviceName;
    const params: EmbCardParams = {
      mac: this.MACNumber,
      key: this.KeyNumber,
      RegionId: this.RCCCompanySelectItem !== '' ? Number(this.RCCCompanySelectItem) : 0
    };
    this.store.dispatch(new fromMyfeatures.GetBindEmbCards(params));
  }

  addRWCC() {
    this.RWCCdisplay = true;
    this.ChangStepWifiCards(0);
  }

  detectRWCCWiFi(result: string) {
    switch (result) {
      case 'ConnectedSuccess': // Connect wifi, get wifi card info success.
        this.ChangStepWifiCards(3);
        this.selectedWiFiNetwork = null;
        break;
      case 'ConnectedFail': // Fail, get back to first step.
        this.ChangStepWifiCards(0);
        break;
      default:
        this.ChangStepWifiCards(0);
    }
  }

  refreshWifiList() {
    this.selectedWiFiNetwork = null;
    this.store.dispatch(new fromMyfeatures.GetWifiList());
  }

  saveRWCCDevice() {
    this.ngxService.start();
    // Cancel revise the device name on add device process.
    // this.wifiCardParams.DeviceName = this.RWCCDeviceName;
    this.store.dispatch(new fromMyfeatures.GetBindDevices({ ...this.wifiCardParams }));
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  UI() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-landing');
    body.classList.remove('body-login');
    // body.classList.remove('layout-toggle');
    body.classList.remove('mobile-toggle');
    body.classList.remove('body-help');
    body.classList.remove('body-addDevice');
  }

  CheckCustmizeDomain() {
    // 判斷是否客製化Domain,若有則跳轉
    const host = window.location.href;
    const pathname = window.location.pathname;
    if (urlPath.CustmizeDomain.includes(pathname)) {
      if (
        this.regionService.GetEnableDomain &&
        this.regionService.GetDomainPath !== '' &&
        this.regionService.GetDomainPath != null &&
        !host.includes(this.regionService.GetDomainPath)
      ) {
        if (
          this.regionService.GetDomainPath.includes('http://') ||
          this.regionService.GetDomainPath.includes('https://')
        ) {
          window.location.href = this.regionService.GetDomainPath;
        } else {
          window.location.href = 'https://' + this.regionService.GetDomainPath;
        }
      }
    }
  }

  onTabChange(event) {
    this.selectedTabIndex = event;
    this.regionService.SetSelectTab = event;
    this.regionService.triggerEvent(geteventEmitterType.SelectTab);
  }

  onKeywordChange() {
    this.regionService.triggerEvent(geteventEmitterType.SelectTab);
  }

  onSortChange() {
    this.regionService.triggerEvent(geteventEmitterType.SelectTab);
  }

  initListener() {
    this.ngZone.runOutsideAngular(() => {
      document.body.addEventListener('click', () => this.reset());
      document.body.addEventListener('mousemove', () => this.reset());
      document.body.addEventListener('keydown', () => this.reset());
    });
  }

  initInterval() {
    this.ngZone.runOutsideAngular(() => {
      this.intervalId = setInterval(() => {
        const now = Date.now();
        if (now - this.lastActionTime >= ReLoadDashboardSec * 1000) {
          this.ngZone.run(() => {
            // const format = moment().format('YYYY:MM:DD HH:mm:ss');
            // console.log('執行 refresh 時間:', format);
            this.refresh();
            this.lastActionTime = Date.now(); // 重設起始時間
          });
        }
      }, this.CHECK_INTERVAL);
    });
  }

  reset() {
    this.lastActionTime = Date.now();
  }
}
